import { render, staticRenderFns } from "./customer-service.vue?vue&type=template&id=4338562f&scoped=true&"
import script from "./customer-service.vue?vue&type=script&lang=js&"
export * from "./customer-service.vue?vue&type=script&lang=js&"
import style0 from "./customer-service.vue?vue&type=style&index=0&id=4338562f&lang=scss&scoped=true&"
import style1 from "./customer-service.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4338562f",
  null
  
)

export default component.exports